import { make } from 'vuex-pathify'
import dottie from 'dottie'
import { api } from '@/api'

const state = {
  publishableKey: null,
  accId: null,
  clientSecret: null,
  checkoutData: {
    itemId: null,
    buyerId: null,
    customAmount: null,
    afterSaleAnswer: null
  },
  readOK: false
}

const getters = {
  ...make.getters(state)
}

const mutations = {
  ...make.mutations(state),

  keyRead(state, { publishableKey, accId }) {
    state.publishableKey = publishableKey
    state.accId = accId
    state.readOK = true
  },

  keyReadFailed(state) {
    state.publishableKey = null
    state.accId = null
    state.readOK = false
  },

  secretRead(state, { clientSecret }) {
    state.clientSecret = clientSecret
  },

  secretReadFailed(state) {
    state.clientSecret = null
  }
}

const actions = {
  async readKey({ commit }, { rewardId }) {
    try {
      const response = await api.post('/publishable-key', { itemId: rewardId })
      const publishableKey = dottie.get(response, 'data.publishableKey', null)
      const accId = dottie.get(response, 'data.accId', null)
      commit('keyRead', { publishableKey, accId })
    } catch (e) {
      commit('keyReadFailed')
    }
  },

  async startSession(
    { commit },
    { itemId, buyerId, customAmount, afterSaleAnswer }
  ) {
    try {
      const { data } = await api.post('/create-checkout-session', {
        itemId,
        buyerId,
        customAmount,
        afterSaleAnswer
      })
      return data
    } catch (e) {
      // commit('keyReadFailed')
    }
  },

  async startSepa(
    { commit },
    { itemId, buyerId, customAmount, afterSaleAnswer }
  ) {
    try {
      const response = await api.post('/initialize-sepa', {
        itemId,
        buyerId
        // customAmount,
        // afterSaleAnswer
      })
      const clientSecret = dottie.get(response, 'data.clientSecret', null)
      commit('secretRead', { clientSecret })
    } catch (e) {
      commit('secretReadFailed')
    }
  },

  async finishSepa(
    { commit },
    { itemId, buyerId, customAmount, afterSaleAnswer, pmId }
  ) {
    try {
      await api.post('/finalize-sepa', {
        itemId,
        buyerId,
        customAmount,
        pmId,
        afterSaleAnswer
      })
    } catch (e) {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
